import { gql } from '@apollo/client';

export const GENERATE_TMS_TASK_DOWNLOAD_REPORT = gql`
    mutation GenerateTmsTaskDownloadReport($filters: TmsTaskFiltersInput, $taskListType: TmsTaskListType!, $timezone: String) {
        generateTmsTaskDownloadReport(filters: $filters, taskListType: $taskListType, timezone: $timezone)
    }
`;

export interface GenerateTmsTaskDownloadReportResponse {
    generateTmsTaskDownloadReport: string;
}

